import React from 'react'
import { FormProvider } from 'react-hook-form'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { IConnectionTypes } from 'types/graphqlTypes'
import { EdiOutboundConnectionConfigModalForm } from '../../forms/EdiOutboundConnectionConfigModalForm'
import { useEdiOutboundConnectionConfigModalForm } from '../../hooks/useEdiOutboundConnectionConfigModalForm'
import { TEdiOutboundConnectionConfigModalSchema } from '../../schema/EdiOutboundConnectionConfigModalSchema'

interface IEdiOutboundConnectionConfigModalProps extends Omit<IModalBaseProps, 'modalType'> {
  defaultValues?: {}
  onSubmit: (data: TEdiOutboundConnectionConfigModalSchema) => void
}

const getDefaultValues = () => {
  return {
    connectionType: IConnectionTypes.SFTP_WITH_PRIVATE_KEY,
    company: {},
    isDisabled: true,
    port: 22,
    username: '',
    secretKey: '',
    pathPrefix: '',
    host: '',
    as2ConnectionConfigId: '',
    interchangeVersion: '00401',
    groupVersion: '004010',
    isaReceiverId: '',
    isaReceiverIdQualifier: '',
    isaSenderId: 'TFXH',
    isaSenderIdQualifier: '02',
    gsSenderId: 'TFXH',
    gsReceiverId: '',
    elementSeparator: '*',
    segmentSeparator: '~',
    componentSeparator: '>',
    repetitionSeparator: '^',
    expect997s: true,
  }
}

export const EdiOutboundConnectionConfigModal = ({
  defaultValues,
  onClose,
  onSubmit,
  open = false,
  ...props
}: IEdiOutboundConnectionConfigModalProps) => {
  const methods = useEdiOutboundConnectionConfigModalForm({
    defaultValues: defaultValues || getDefaultValues(),
  })

  const { handleSubmit } = methods || {}

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Cancel',
      action: () => {
        onClose()
      },
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
    {
      label: 'Save',
      action: handleSubmit((data: TEdiOutboundConnectionConfigModalSchema) => {
        onSubmit(data)
        onClose()
      }),
      type: 'confirm',
      dataTest: 'confirm-button',
    },
  ]

  return (
    <ModalBase
      dataTest='EdiOutboundConnectionConfigModal'
      modalType={MODAL_TYPES.form}
      size={4}
      open={open}
      actions={actions}
      onClose={onClose}
      {...props}>
      <FormProvider {...methods}>
        <EdiOutboundConnectionConfigModalForm />
      </FormProvider>
    </ModalBase>
  )
}
